module.exports = __webpack_public_path__ + "static/56f3170a70debccc2fae249fb9bc6985205f9c9d61a2a44180848c1909accd3e-1958dc1f41b81ff2e20c2a99350d162c.jpeg";